<template>
  <div class="">
    <header id="headerContent"
      class="d-flex flex-wrap align-items-center justify-content-center justify-content-md-between mb-4 border-bottom"
      style="padding-left:5%;padding-right:5%;">
      <div style="box-sizing: border-box">
        <img src="@/assets/images/wordmark2.svg" style="
              width: 140px;
              height: 60px;
              margin-top: 2%;
              margin-left: 0px;
              position: static;
            " />
      </div>
      <a href="http://modspec.com.au/"
        class="d-flex align-items-center col-md-3 mb-2 mb-md-0 text-dark text-decoration-none">
      </a>

      <div class="col-12 col-md-auto mb-2 text-end mb-md-0">
        <ul class="nav" style="display:block;position:relative;float:right;">

          <li class="nav-item dropdown" style="width:auto;float:right;margin-left:10px;">
            <router-link v-if="nameUser == null" class="nav-link link-modspec modspec_menu" to="/login"
              style="margin-top:5px;">Log In <i class="bi bi-chevron-right"></i></router-link>

            <div v-else class="box-menu">
              <a href="#" class="nav-link link-modspec modspec_menu" style="height: 40px;padding-left:10px;"
                title="User" data-bs-toggle="dropdown">
                <span class="d-md-block dropdown-toggle ps-2"><img class="icon" src="@/assets/images/user.svg" />
                  {{ nameUser }}</span>
              </a>

              <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                <li>
                  <a class="dropdown-item d-flex align-items-center" href="#" @click="logout">
                    <span class="nav-link link-modspec">Log out</span>
                  </a>
                </li>
                <li v-if="rol == 'user'">
                  <a class="dropdown-item d-flex align-items-center" href="/user">
                    <span class="nav-link link-modspec">Go to client hub</span>
                  </a>
                </li>
                <li v-else>
                  <a class="dropdown-item d-flex align-items-center" href="/administration">
                    <span class="nav-link link-modspec">Go to admin site</span>
                  </a>
                </li>
              </ul>

            </div>



          </li>
          <li class="nav-item dropdown" style="width:auto;float:right;margin-left:10px;">
            <div class="box-menu">
              <a v-tooltip="{ text: 'Back to website', theme: { placement: 'bottom', color: '#fff', 'background-color': '#2a2c2e', 'font-size': '0.875rem', width: 'fit-content', padding: '5px', } }"
                class="nav-link link-modspec modspec_menu" href="http://modspec.com.au/"
                style="font-size:1.3rem; font-weight: 600;color:#000;"><i class="bi bi-house-door-fill"></i></a>
            </div>
          </li>
        </ul>
      </div>

    </header>
  </div>
</template>
<script scope>
export default {
  name: "header-component",
  data: function () {
    return {};
  },
  components: {},
  mounted() { },
  computed: {
    nameUser() {
      return this.$vtc.getNameLogueado();
    },
    rol() {
      let usrr = this.$vtc.getUsuarioLogueado();
      if (usrr) {
        return usrr.rol
      }
      return null
    }
  },
  methods: {
    logout() {
      let usr = this.$vtc.getUserToken();
      let self = this;

      self.$vtc.deleteUserLogueado(); //-QUITAR luego de pruebas

      this.$vtc.vtcFetch("/Auth/Logout?u=" + usr, null, 'API2').then(function (r) {
        if (r === true) {
          self.$vtc.deleteUserLogueado();
          window.location.href = self.$vtc.getConfig().getHomeUrl() + "/login";
        }
      });
    }
  },
};
</script>
<style scoped>
#imgLogo {
  width: 260px;
}

#headerContent {
  height: 70px;
}

.icon {
  width: 24px;
  height: 24px;
}

.link-modspec {
  font-size: 0.75rem;
  font-weight: 600;
  color: #000 !important;
}

.box-menu {
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  box-sizing: border-box;
  border: 1px solid #aaa;
  border-radius: 10px;
  height: 40px;
}

@media only screen and (max-width: 575px) and (max-width: 991px) {
  #imgLogo {
    width: 260px;
  }

  #headerContent {
    height: 140px;
  }
}
</style>
